import { render } from "./EventIcon.vue?vue&type=template&id=40692e36&scoped=true"
import script from "./EventIcon.vue?vue&type=script&lang=js"
export * from "./EventIcon.vue?vue&type=script&lang=js"

import "./EventIcon.vue?vue&type=style&index=0&id=40692e36&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40692e36"]])

export default __exports__